// extracted by mini-css-extract-plugin
export var avatarBone = "_9-4";
export var buttonBone = "_9-3";
export var continueBone = "_9-a";
export var frame = "_9-1";
export var logoBone = "_9-2";
export var pickerGrid = "_9-d";
export var pitchBone = "_9-9";
export var productBone = "_9-8";
export var sectionBone = "_9-7";
export var shell = "_9-0";
export var skeletonPulse = "_9-b";
export var subtitleBone = "_9-6";
export var titleBone = "_9-5";
export var viewport = "_9-c";